export default __webpack_public_path__ + "static/media/react.e68b35f4.svg";